import React from 'react';
import { Link } from 'react-router';
import path from 'ramda/es/path';

import i18n from 'app/i18n';
import api from 'app/actions/api';
import { popup } from 'app/common/actions/popup';
import { Trans } from 'react-i18next';
import { getSignByCode } from 'app/common/components-next/currency';

/**
/* Добавление пакета смс
*/

export const SUBSCRIBE_BUNDLE_REQUEST = 'SUBSCRIBE_BUNDLE_REQUEST';
export const SUBSCRIBE_BUNDLE_SUCCESS = 'SUBSCRIBE_BUNDLE_SUCCESS';
export const SUBSCRIBE_BUNDLE_FAILURE = 'SUBSCRIBE_BUNDLE_FAILURE';

export const subscribeBundleRequest = () => ({
  type: SUBSCRIBE_BUNDLE_REQUEST,
});

export const subscribeBundleSuccess = data => ({
  type: SUBSCRIBE_BUNDLE_SUCCESS,
  payload: data,
});

export const subscribeBundleFailure = errString => ({
  type: SUBSCRIBE_BUNDLE_FAILURE,
  payload: { err: errString },
});


export const subscribeBundle = (subId, bundleId) => async (dispatch, getState) => {
  const { country_iso_code: code } = getState().dealer;
  const postData = {
    id: subId,
    bundle_id: bundleId,
  };
  dispatch(subscribeBundleRequest());
  try {
    const { data } = await api('cabinet/subscriptions/bundle', 'post', { data: postData });
    if (data.result) {
      delete data.result;
    }
    dispatch(subscribeBundleSuccess({ subs: data }));
    dispatch(popup(<span>{i18n.t('app:request_bunble_subscribe_success')}</span>));
    return true;
  } catch (error) {
    const errCode = path(['response', 'status'], error);
    const amount = path(['response', 'data', 'amount'], error);

    if (errCode === 403) {
      const amountCurrency = `${amount}${getSignByCode(code)}`;

      dispatch(subscribeBundleFailure(
        <span>
          <Trans
            i18nKey="app:request_not_enough_funds"
            values={{ amount: amountCurrency }}
          >
            {'Недостаточно {{amount}} на счету. '}
            <Link to={`/finances/fund/refill/self/primary/step2?amount=${amount}`}>
              {'Пополнить'}
            </Link>
          </Trans>
        </span>
      ));
      return false;
    }
    dispatch(subscribeBundleFailure(i18n.t('app:request_bunble_subscribe_failed')));
    return false;
  }
};
